import { render, staticRenderFns } from "./scgd.vue?vue&type=template&id=0ad30908&scoped=true"
import script from "./scgd.vue?vue&type=script&lang=js"
export * from "./scgd.vue?vue&type=script&lang=js"
import style0 from "./scgd.vue?vue&type=style&index=0&id=0ad30908&prod&lang=scss&scoped=true"
import style1 from "./scgd.vue?vue&type=style&index=1&id=0ad30908&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad30908",
  null
  
)

export default component.exports